module.exports = __webpack_public_path__ + "b50d41b50b89aca02b428645c6f55a8d.pdf";